// This is a duplicate of the same file in foundations-theming-base. Once Quartz
// is updated to use this file, the foundations-theming-base file will be removed.
import { setupTheme } from 'foundations-theming-base/js/setup-theme';
import multiTheme from 'foundations-theming-base/js/stable/multi-theme';
window.__hubspotTheme = multiTheme;
setupTheme();